<template>
    <DFormRow
        :label="__('customers.contracts.start_date')"
        :error="errors.start_date"
        :is-required="true"
    >
        <DDateFormatInput
            :id="`start_date${idSuffix}`"
            format="YYYY-MM-DD"
            :model-value="modelValue"
            type="date"
            :disabled="disabled"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'PhaseStartDate',
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        idSuffix: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue']
}
</script>
